import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { StreamAction } from '../stream.action';

type IDependencies = IClientApiDependencySegment;

export const removeStreamEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(StreamAction.remove.started),
  mergeMap((params) => {
    const { streamId } = params;

    return dependencies.api.deleteStream({ streamId }).pipe(
      mergeMap(() => {
        return [
          StreamAction.remove.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          StreamAction.remove.failed({ params, error: null }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
